import React from "react";
import "./App";


export default function CurrentDate(){
 let date = new Date();
 let days = [
   "Sunday",
   "Monday",
   "Tuesday",
   "Wednesday",
   "Thursday",
   "Friday",
   "Saturday",
 ];
 let day = date.getDay();
 let hour = date.getHours();
 let min = date.getMinutes();

    return (
      <div>
        <h5 className="Current-date">
          {days[day]} {hour}:{min}{" "}
        </h5>
      </div>
    );
}